/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable sort-keys */
import { darken, lighten, rgba } from 'polished';
import Theme from '../types/theme';
import { decrease, increase } from '../colors/chartPalette';
import * as colorPalette from '../colors/defaultPalette';
import GridTheme from '../types/theme/grid';

const colors = {
  accent: colorPalette.orange,
  accentDark: colorPalette.orangeDark,
  accentDarker: colorPalette.orangeDarker,
  accentForeground: colorPalette.black,
  accentLight: colorPalette.orangeLight,
  accentLighter: colorPalette.orangeLighter,
  accentMuted: '#b68435',

  actionDisabled: rgba(colorPalette.neutral500, 0.8),
  actionDisabledBackground: rgba(colorPalette.neutral500, 0.24),
  actionFocus: rgba(colorPalette.neutral500, 0.24),
  actionHover: rgba(colorPalette.neutral500, 0.08),
  actionSelected: rgba(colorPalette.neutral500, 0.16),

  background: '#000000',
  backgroundActive: lighten(0.15, '#000000'),
  backgroundInactive: lighten(0.25, '#000000'),

  banner: colorPalette.black,

  blindMode: 'none',

  border: '#696969',
  borderDark: colorPalette.greyDarker,
  borderLight: colorPalette.greyLight,
  borderUnified: colorPalette.grayDark,

  brand: colorPalette.blue,
  brandDark: colorPalette.blueDark,
  brandDarker: colorPalette.blueDarker,
  brandForeground: colorPalette.white,

  brandLight: colorPalette.blueLight,
  brandLighter: colorPalette.blueLighter,
  brandMuted: '#008FD9',
  brandUnified: colorPalette.blue,

  buttonPrimary: colorPalette.white,
  buttonPrimaryBackground: '#0076cd',
  buttonPrimaryBackgroundHover: colorPalette.blue,
  buttonPrimaryBorder: '#0076cd',
  buttonPrimaryUnified: colorPalette.white,
  buttonPrimaryBackgroundUnified: '#0076cd',

  danger: colorPalette.red,
  dangerDark: colorPalette.redDark,
  dangerDarker: colorPalette.redDarker,
  dangerForeground: colorPalette.white,
  dangerLight: colorPalette.redLight,
  dangerLighter: colorPalette.redLighter,

  dropdownBackground: '#000000',
  dropdownBackgroundActive: lighten(0.15, '#000000'),

  foreground: 'white',
  foregroundActive: darken(0.1, 'white'),
  foregroundInactive: darken(0.2, 'white'),
  foregroundMuted: colorPalette.neutral200,

  information: '#008fd9',

  statistic: {
    negative: colorPalette.red,
    neutral: colorPalette.white,
    positive: colorPalette.green,
  },

  success: colorPalette.green,
  successDark: colorPalette.greenDark,
  successDarker: colorPalette.greenDarker,
  successForeground: colorPalette.white,
  successLight: colorPalette.greenLight,
  successLighter: colorPalette.greenLighter,

  warning: colorPalette.yellow,
  warningDark: colorPalette.yellowDark,
  warningDarker: colorPalette.yellowDarker,
  warningForeground: colorPalette.white,
  warningLight: colorPalette.yellowLight,
  warningLighter: colorPalette.yellowLighter,
};

const chart = {
  color: {
    accentColor1: 'rgba(73, 83, 96, .3)',
    accentColor2: 'rgba(73, 83, 96, 1)',
    mainColor: 'rgba(255, 255, 255, 1)',
    periods: {
      decrease,
      increase,
    },
    tooltipBackground: 'rgba(0, 0, 0, 1)',
  },
};
const grid: GridTheme = {
  color: {
    background: lighten(0.15, '#000000'),
  },
};

const highContrast: Partial<Theme> = {
  chart,
  grid,
  colors: colors,
  name: 'highContrast',
};

export default highContrast;
